export default {
	vision_mission(state) {
		return state.vision_mission
	},
}
